export default class Base {
    constructor(transport) {
        this.transport = transport;
    }
    async getAddress(data) {
        return "";
    }
    async signTransaction(data) {
        return "";
    }
}